import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle, TextareaAutosize,
    TextField
} from "@material-ui/core";
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import trLocale from 'date-fns/locale/tr';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
 import React, { useState} from "react";
import axios from "axios";
import { api } from "./api/client";
import {DatePicker} from "@mui/lab";
import {isValid} from "date-fns";
import SendIcon from '@mui/icons-material/Send';
import IconButton from "@mui/material/IconButton";
import {toast, ToastContainer} from "react-toastify";
export default function ModalBoxSevkiyat(props) {
    const [open, setOpen] = useState(false);
    const [state, setState] = useState({
        idd:props.id,
        teklif_tarihi:''

    });
    const teklifTarihiSecili = state.teklif_tarihi instanceof Date && isValid(state.teklif_tarihi);



    const handleClickOpen = () => {
        setOpen(true);

    };

    const handleClose = () => {
        setOpen(false);
    };
    return (
        <div>
            <IconButton variant="outlined" size={"small"} color={'success'} onClick={handleClickOpen }>
                <SendIcon />
            </IconButton>
             <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="form-dialog-title"
                maxWidth="md"
            >
                <DialogTitle id="form-dialog-title">Onay Bekleyenlere Gönder</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Tarih Giriniz
                    </DialogContentText>
                    <LocalizationProvider dateAdapter={AdapterDateFns} locale={trLocale}>
                        <DatePicker
                            label="Teklif Tarihi"
                            value={state.teklif_tarihi}
                            onChange={(newValue) => {
                                setState((prevState) => ({...prevState, 'teklif_tarihi':newValue}));
                            }}
                            renderInput={(params) => <TextField {...params} />}
                        />
                    </LocalizationProvider>

                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} color="primary">
                        İptal
                    </Button>
                    <Button

                        onClick={

                            async () => {
                                if (!teklifTarihiSecili) {
                                    return;
                                }

                                    console.log(props.row);
                             await api.post('/teklifler/' + props.id + '/onay-bekleyen?id=' + props.id, {

                                 'teklif_tarihi': state.teklif_tarihi,
                             })
                                .then((response) => {
                                    // Success 🎉
                                    console.log(response);
                                    handleClose();
                                    props.bekleyenlerde(true);
                                    toast.success("Onay Bekkleyenler aşamasına aktarıldı");

                                })
                                .catch((error) => {
                                    // Error 😨
                                    if (error.response) {
                                        /*
                                         * The request was made and the server responded with a
                                         * status code that falls out of the range of 2xx
                                         */
                                        console.log(error.response.data);
                                        console.log(error.response.status);
                                        console.log(error.response.headers);
                                    } else if (error.request) {
                                        /*
                                         * The request was made but no response was received, `error.request`
                                         * is an instance of XMLHttpRequest in the browser and an instance
                                         * of http.ClientRequest in Node.js
                                         */
                                        console.log(error.request);
                                    } else {
                                        // Something happened in setting up the request and triggered an Error
                                        console.log('Error', error.message);
                                    }
                                    console.log(error.config);
                                });
                            setState({open:false});
                        }}
                        color="primary"
                        disabled={!teklifTarihiSecili}
                    >
                        Gönder
                    </Button>
                </DialogActions>
            </Dialog>
            <ToastContainer
                position="bottom-right"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover

            />

        </div>
    )
}
